import SvgIcon from './SvgIcon.vue';

const install = function(Vue, options) {
  Vue.component(options && options.tagName ? options.tagName : 'SvgIcon', SvgIcon);
};

export default { install };
